import ApiBase from 'Services/Api/ApiBase';

class CovidTestEntry extends ApiBase {
    route = '/admin/covid/covid-test-entry';
};

export default new CovidTestEntry();